import type { NodeMap, Node2dExtracted } from ".."

export const findDeadEnds = (ExtractedPoints: NodeMap): Set<Node2dExtracted> => {
  const deadEnds: Set<Node2dExtracted> = new Set()

  ExtractedPoints.forEach((ExtractedPoint) => {
    if (ExtractedPoint.edgeIds.length < 2) {
      deadEnds.add(ExtractedPoint)
    }
  })

  return deadEnds
}
